import { EdgeInsets } from "./useSafeAreaInsets.types";

export const useSafeAreaInsets = (): EdgeInsets => ({
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
});
